// extracted by mini-css-extract-plugin
module.exports = {"primary":"#ff0080","control":"#f08f20"};